import { FC, useEffect, useState } from 'react';
import { Tabs as AntDesignTabs } from 'antd';
import { TbSettings, TbUsersGroup } from 'react-icons/tb';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import { capitalizeFirstLetter } from '@/utilities';

// interface TabsProps {}

const Tabs: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    const panes = [
        {
            id: 'members',
            key: 'members',
            label: (
                <span>
                    <TbUsersGroup style={{ marginRight: '0.25rem', verticalAlign: '-0.125rem' }} />
                    Members
                </span>
            ),
            disabled: loading,
        },
        {
            id: 'settings',
            key: 'settings',
            label: (
                <span>
                    <TbSettings style={{ marginRight: '0.25rem', verticalAlign: '-0.125rem' }} />
                    Settings
                </span>
            ),
            disabled: loading,
        },
    ];

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 750);
    }, []);

    const navigate = useNavigate();
    const location = useLocation();
    const { teamId } = useParams<{ teamId: string }>();

    const url = `/settings/workspace/permissions/teams/${teamId}`;

    const [activeTab, setActiveTab] = useState(location.pathname.split('/')[6]);

    useEffect(() => {
        setActiveTab(location.pathname.split('/')[6]);
    }, [location]);

    const onChange = (activeKey: string) => {
        setActiveTab(capitalizeFirstLetter(activeKey));

        navigate(`${url}/${activeKey}`);
    };

    return (
        <AntDesignTabs
            animated={true}
            activeKey={activeTab}
            tabBarStyle={{ width: '100%', padding: 0, marginBottom: 0 }}
            onChange={onChange}
            items={panes}
            size='small'
        />
    );
};

export default Tabs;
